/* CAFFREY Essential Wipes page script (Claude Code, launch builder, WORKFLOW-B, 2026-10-07).
   Progressive enhancement only; the page works without it.
   1. Hero zoom: the "+" link opens the approved packshot in a <dialog> (without JS the link opens the image file).
   2. "Good shoes. Busy days." rail: arrows, a quiet "n / 5" counter and slide-by-slide keys (swipe works without JS).
   3. Hairline callouts draw in once when they enter the viewport; never under prefers-reduced-motion.
   4. Below-the-fold photos wait in <noscript data-ew-defer> until the hero has loaded and they are near the screen.
   Buying (Add to cart, Shop Pay, sticky bar) is the kit's job: cf-kit.js + Dawn product-form.js. */
(function () {
  if (window.cfEwPage) return;
  window.cfEwPage = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initZoom(scope) {
    scope.querySelectorAll('[data-ew-zoom]').forEach(function (link) {
      var dlg = document.getElementById(link.getAttribute('data-ew-zoom'));
      if (!dlg || typeof dlg.showModal !== 'function' || link.dataset.ewReady) return;
      link.dataset.ewReady = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (!dlg.querySelector('img')) {
          var img = new Image();
          img.width = 1080;
          img.height = 1080;
          img.decoding = 'async';
          img.alt = dlg.getAttribute('data-ew-alt') || '';
          img.src = link.getAttribute('href');
          dlg.appendChild(img);
        }
        dlg.showModal();
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('[data-ew-close]')) dlg.close();
      });
      dlg.addEventListener('close', function () {
        try { link.focus({ preventScroll: true }); } catch (err) { link.focus(); }
      });
    });
  }

  function initRail(root) {
    var rail = root.querySelector('[data-ew-rail]');
    var controls = root.querySelector('[data-ew-controls]');
    if (!rail || !controls || rail.dataset.ewReady) return;
    var slides = Array.prototype.slice.call(rail.querySelectorAll('[data-ew-slide]'));
    var total = slides.length;
    if (total < 2) return;
    rail.dataset.ewReady = '1';
    var count = root.querySelector('[data-ew-count]');
    var status = root.querySelector('[data-ew-status]');
    var prev = root.querySelector('[data-ew-step="-1"]');
    var next = root.querySelector('[data-ew-step="1"]');
    var index = 0;
    var ticking = false;
    var pending = false;
    var settle = null;
    controls.hidden = false;

    function announce() {
      if (!pending || !status) return;
      pending = false;
      status.textContent = (status.getAttribute('data-label') || '').replace('[index]', index + 1).replace('[total]', total);
    }
    function later(ms) {
      window.clearTimeout(settle);
      settle = window.setTimeout(announce, ms);
    }

    function offset(i) { return slides[i].offsetLeft - slides[0].offsetLeft; }
    function maxScroll() { return rail.scrollWidth - rail.clientWidth; }
    function nearest() {
      if (rail.scrollLeft >= maxScroll() - 2) return total - 1;
      var best = 0, gap = Infinity;
      for (var i = 0; i < total; i++) {
        var d = Math.abs(offset(i) - rail.scrollLeft);
        if (d < gap) { gap = d; best = i; }
      }
      return best;
    }
    function render() {
      ticking = false;
      index = nearest();
      if (count) count.textContent = (index + 1) + ' / ' + total;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= maxScroll() - 2;
    }
    function go(i) {
      i = Math.max(0, Math.min(total - 1, i));
      pending = true;
      rail.scrollTo({ left: Math.min(offset(i), maxScroll()), behavior: reduce ? 'auto' : 'smooth' });
      later(reduce ? 80 : 800); /* announced once the rail settles, so it matches the visible counter */
    }
    rail.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(render); }
      if (pending) later(200);
    }, { passive: true });
    window.addEventListener('resize', render, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    rail.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowRight' || k === 'ArrowLeft' || k === 'Home' || k === 'End') {
        e.preventDefault();
        go(k === 'Home' ? 0 : k === 'End' ? total - 1 : index + (k === 'ArrowRight' ? 1 : -1));
      }
    });
    render();
  }

  /* 4. Below-the-fold photos held in <noscript data-ew-defer> (snippets/cf-ew-image.liquid). They sat inside Chrome's lazy-load
     distance and shared a slow phone's bandwidth with the hero, so they are inserted once the hero has loaded (4 s at the
     latest) and only when their box is within 800 px of the screen. A [data-ew-hold] box is filled as one unit (the whole
     carousel rail at once, so no frame is ever blank while swiping). Without JavaScript the noscript images render. */
  var held = [];
  var gateOpen = false;
  var holdIO = null;
  function fill(box) {
    box.querySelectorAll('noscript[data-ew-defer]').forEach(function (ns) {
      var t = document.createElement('template');
      t.innerHTML = ns.textContent;
      ns.replaceWith(t.content);
    });
  }
  function watchBox(box) {
    if (!('IntersectionObserver' in window)) { fill(box); return; }
    if (!holdIO) {
      holdIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { holdIO.unobserve(en.target); fill(en.target); }
        });
      }, { rootMargin: '800px 0px 800px 0px' });
    }
    holdIO.observe(box);
  }
  function openGate() {
    if (gateOpen) return;
    gateOpen = true;
    held.forEach(function (box) { if (box.isConnected) watchBox(box); });
  }
  function initHold(scope) {
    scope.querySelectorAll('[data-ew-hold]').forEach(function (box) {
      if (box.dataset.ewHeld) return;
      box.dataset.ewHeld = '1';
      held.push(box);
      if (gateOpen) watchBox(box);
    });
  }
  function armGate() {
    var hero = document.querySelector('.cf-ew-hero__img');
    if (!hero || (hero.complete && hero.naturalWidth > 0)) { openGate(); return; }
    hero.addEventListener('load', openGate, { once: true });
    hero.addEventListener('error', openGate, { once: true });
    window.setTimeout(openGate, 4000);
  }

  var observer = null;
  function initDraw(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); observer.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.2 });
    }
    scope.querySelectorAll('[data-ew-draw]').forEach(function (fig) {
      if (fig.classList.contains('cf-ew-draw')) return;
      var r = fig.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return; /* already on screen: leave the lines drawn */
      fig.classList.add('cf-ew-draw');
      observer.observe(fig);
    });
  }

  function init(scope) {
    initHold(scope);
    initZoom(scope);
    scope.querySelectorAll('[data-ew-carousel]').forEach(initRail);
    if (scope.matches && scope.matches('[data-ew-carousel]')) initRail(scope);
    initDraw(scope);
  }
  function boot() { init(document); armGate(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { if (e.target) init(e.target); });
})();
